const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

const cache = new Map();

const clone = (value) => {
  if (typeof structuredClone === 'function') {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value));
};

const buildUrl = (endpoint, params) => {
  const search = params && params.toString() ? `?${params.toString()}` : '';
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  if (API_BASE) {
    return `${API_BASE}${path}${search}`;
  }
  return `${path}${search}`;
};

const fetchJson = async (endpoint, params, cacheKey) => {
  const url = buildUrl(endpoint, params);
  const response = await fetch(url);
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    const error = new Error(`Request failed with status ${response.status}`);
    error.status = response.status;
    error.body = text;
    throw error;
  }
  const data = await response.json();
  if (cacheKey) {
    cache.set(cacheKey, clone(data));
  }
  return data;
};

const buildParams = ({ windowMonths, startMonth, endMonth, products }) => {
  const params = new URLSearchParams();
  if (windowMonths) params.set('baselineMonths', String(windowMonths));
  if (startMonth) params.set('startYearMonth', startMonth);
  if (endMonth) params.set('endYearMonth', endMonth);
  if (products && products.length) params.set('products', products.join(','));
  return params;
};

export const fetchHeatmapData = async ({ windowMonths = 6, startMonth, endMonth, products } = {}) => {
  const key = `heatmap:${JSON.stringify({ windowMonths, startMonth, endMonth, products })}`;
  if (cache.has(key)) {
    return clone(cache.get(key));
  }
  const params = buildParams({ windowMonths, startMonth, endMonth, products });
  const data = await fetchJson('/analytics/production/heatmap', params, key);
  return data;
};

export const fetchLineData = async ({ windowMonths = 6, startMonth, endMonth, products } = {}) => {
  const key = `line:${JSON.stringify({ windowMonths, startMonth, endMonth, products })}`;
  if (cache.has(key)) {
    return clone(cache.get(key));
  }
  const params = buildParams({ windowMonths, startMonth, endMonth, products });
  const data = await fetchJson('/analytics/production/line', params, key);
  return data;
};

export const invalidateProductionAnalyticsCache = () => cache.clear();
